const Faq = () => {
	const faqs = [
		{
			question: 'What is PagePilot.ai used for?',
			answer:
				'PagePilot.ai is a tool that helps you launch and test e-commerce products faster. You just need to copy and paste the Aliexpress URL or the product link directly from another Shopify store and we build a unique and high converting landing page in just a few minutes, using AI. More on that, we help you generate the Ads Creatives easily and every day we give you 10 different and unique winning products to test.',
		},
		{
			question: 'Is the subscription commitment-free?',
			answer: 'Absolutely! You can try PagePilot.ai for free. No commitment, no credit card required!',
		},
		{
			question: 'How can I import to Shopify the generated product page?',
			answer:
				'You will need to connect your Shopify Store to PagePilot. Once you have done that, you can import the product page to your Shopify store with just one click. Easy peasy!',
		},
		{
			question: 'What services does PagePilot.ai offer?',
			answer:
				'Product Page generation (from Aliexpress or Shopify link), Ad Creatives, and 10 Daily Winning Products to test.',
		},
		{
			question: 'How many languages does PagePilot.ai support?',
			answer:
				'You can generate the product page in 30+ languages. If your language is not there, please contact us and we will add it for you.',
		},
		{
			question: 'Can I create products during the free period and link them to my store?',
			answer:
				'You can create up to 3 product pages on your free plan. In order to import them in Shopify, you need a paid plan.',
		},
		{
			question:
				'After I cancel my subscription, will the products I created with PagePilot.ai be deleted? What happens to the products I imported into my Shopify store?',
			answer:
				'If you decide to cancel your subscription, the products you created with PagePilot.ai will not be deleted; however, you will lose the ability to create new products using PagePilot. The products you imported into your Shopify store will remain unaffected.',
		},
		{
			question: 'How do I cancel my subscription?',
			answer:
				"Simply log in to the platform, click on the Billing from menu and open the customer portal. Even after canceling your subscription, PagePilot.ai remains available to you until the end of your current period, whether it's monthly or annually.",
		},
	];

	return (
		<section className="-mt-8 px-6" id="faq">
			<div className="bg-transparent mx-auto flex w-full max-w-[900px] flex-col overflow-hidden bg-[#050520] pt-6 backdrop-blur-xl md:pt-20">
				<div className="mb-12 flex flex-col gap-6">
					<h2 className="text-transparent mx-auto bg-clip-text text-center text-3xl font-extrabold lg:text-5xl lg:leading-[60px]">
						<span className="text-transparent bg-gradient-to-b from-white from-40% to-[#b2b2b2] bg-clip-text">
							Frequently Asked Questions
						</span>
					</h2>
					<div className="mx-auto max-w-2xl text-center text-lg text-white lg:text-xl">
						Need more information about PagePilot.ai? Find all your answers here.
					</div>
				</div>

				<div className="flex flex-col gap-6">
					{faqs.map((faq, index) => (
						<details
							className="group appearance-none rounded-3xl border border-white/20 outline-none transition duration-300 hover:cursor-pointer hover:bg-white/5"
							key={index}>
							<summary className="flex w-full appearance-none items-center justify-between px-6 py-6">
								<span className="pr-10 text-lg text-white">{faq.question}</span>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="h-[22px] w-[22px] min-w-[22px] fill-white transition duration-500 group-open:rotate-180"
									viewBox="0 0 256 256">
									<path d="M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z"></path>
								</svg>
							</summary>

							<article className="px-6 pb-6 transition-opacity duration-500 ease-in-out">
								<p className="text-gray-DEFAULT-400">{faq.answer}</p>
							</article>
						</details>
					))}
				</div>
			</div>
		</section>
	);
};

export default Faq;
